module.exports = __webpack_public_path__ + "static/media/bat1.b5fa4d3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/battery/bat1.png
// module id = 469
// module chunks = 0